export const Payment = {
  getMemberInfo: (member, paymentInfo) => {
    let getSubscriptionsInfo = (member, paymentInfo) => {
      let curSubsInfo = JSON.parse(member.attributes['custom:subscriptionInfo'])
      let paymentIds = curSubsInfo.p;
      const paymentList = paymentIds.split('|');
      if (paymentList.includes(paymentInfo.tx.paymentID)) {
        return false;
      }else{
        paymentIds = paymentIds + '|' + paymentInfo.tx.paymentID;
      }
      return {
        p: paymentIds,
      }
    };
    let getValidThru = (member) => {
      let curPaymentInfo = JSON.parse(member.attributes['custom:txInfo'])
      let curValidThru = new Date();
      if (curPaymentInfo && curPaymentInfo.v) {
        let memberValidThru = new Date(curPaymentInfo.v);
        if (memberValidThru > curValidThru) {
          curValidThru = memberValidThru;
        }
      }

      return curValidThru;
    };
    let getPaymentInfo = (member, paymentInfo) => {
      // 31 days to ms
      let increment = 2678400000;
      if ((paymentInfo.membershipType === 'yearly') || (paymentInfo.membershipType === 'year')) {
        increment = 31536000000;
      }else if ((paymentInfo.membershipType === 'monthly') || (paymentInfo.membershipType === 'month')) {
        increment = 2678400000;
      }else if (paymentInfo.membershipType === 'free') {
        increment = 604800000;
      }
      const curValidThru = getValidThru(member);
      let newValidThru = new Date();
      newValidThru.setTime(curValidThru.getTime() + increment);
      return {
        tx: paymentInfo.tx.payerID + '|' + paymentInfo.amount + '|' + paymentInfo.discountCode,
        v: newValidThru.getTime(),
      };
    }
    let getMembershipInfo = (paymentInfo) => {
      let startDate = new Date();
      let endDate = new Date();
      const curValidThru = getValidThru(member);
      if (curValidThru > startDate) {
        startDate = curValidThru;
      }
      if ((paymentInfo.membershipType === 'yearly') || (paymentInfo.membershipType === 'year')) {
        endDate.setTime(startDate.getTime() + 31536000000);
      }else if ((paymentInfo.membershipType === 'monthly') || (paymentInfo.membershipType === 'month')) {
        endDate.setTime(startDate.getTime() + 2678400000);
      }else if (paymentInfo.membershipType === 'free') {
        endDate.sesetTimetDate(startDate.getTime() + 604800000);
      }
      const membershipInfo = startDate.getTime() + '|' + endDate.getTime() + '|' + paymentInfo.membershipType;
      let membershipHistory = JSON.parse(member.attributes['custom:membershipInfo']);
      if (membershipHistory.length > 0) {
        membershipHistory.push(membershipInfo);
      }else{
        // All membership has to be an array of strings
        let freeDate = new Date();
        freeDate.setDate(startDate.getDate() + 7);
        membershipHistory = [startDate.getTime() + '|' + freeDate.getTime() + '|free'];
        membershipHistory.push(membershipInfo);
      }
    
      return membershipHistory;
    };

    const subscriptionsInfo = getSubscriptionsInfo(member, paymentInfo);
    if (subscriptionsInfo === false) {
      return false;
    }
    const memberPaymentInfo = getPaymentInfo(member, paymentInfo);
    const membershipHistory = getMembershipInfo(paymentInfo);

    return {
      'custom:membershipInfo': JSON.stringify(membershipHistory),
      'custom:txInfo': JSON.stringify(memberPaymentInfo),
      'custom:subscriptionInfo': JSON.stringify(subscriptionsInfo),
    };
  },
  resetMemberInfo: (member, paymentInfo) => {
    return {
      'custom:membershipInfo': '["1590125319498|1590730119498|free"]',
      'custom:txInfo': '{"tx":null,"v":1592158095223}',
      'custom:subscriptionInfo': '{"p":"free"}',
    };
  }
}
